import ActionButton from "@/components/Button/ActionButton";
import { HStack } from "@/components/Layout";
import { Text } from "@/components/Typography/Text";
import { Button } from "@/components/ui/button";
import { useCommonTranslation } from "@/hooks/useCommonTranslation";

import type { EditButtonGroupProps } from "../cform-types";

/**
 * セクション単位の
 * 編集 / キャンセル・保存ボタン
 */
export function CFormSectionEditButtonGroup(props: EditButtonGroupProps) {
  const tc = useCommonTranslation();

  if (!props.display) return null;

  return !props.isEditing ? (
    <Button
      variant="secondary"
      className="h-9 px-2 min-w-12"
      onClick={props.onStartEdit}
    >
      <Text variant="labelSmall">{tc("action.edit")}</Text>
    </Button>
  ) : (
    <HStack className="gap-2">
      <ActionButton onClick={props.onCancel} size="sm" variant="outline">
        {tc("action.cancel")}
      </ActionButton>
      <ActionButton
        onClick={props.onSave}
        size="sm"
        isLoading={props.isPending}
      >
        {tc("action.save")}
      </ActionButton>
    </HStack>
  );
}
